import React from 'react'

function Desuscripcion() {
    return (
        <div>
            <section class="banner-section-two">
                <div class="shape-one"><img src="assets/images/shape/shape-11.png" alt=""/></div>
                <div class="shape-two"><img src="assets/images/shape/shape-12.png" alt=""/></div>
                <div class="shape-three"><img src="assets/images/shape/shape-13.png" alt=""/></div>
                <div class="shape-four"><img src="assets/images/shape/shape-14.png" alt=""/></div>
                <div class="shape-five"><img src="assets/images/shape/shape-15.png" alt=""/></div>
                <div class="shape-six"><img src="assets/images/shape/shape-16.png" alt=""/></div>
                <div class="auto-container">
                    <div class="content-box">
                        <div>
                            <h2>Desuscripción confirmada</h2>

                            <div class="text">
                                Tu solicitud ha sido procesada correctamente.
                                <br/>
                                A partir de este momento, dejarás de recibir nuestras comunicaciones por correo electrónico.
                                <br/><br/>
                                Gracias por habernos permitido mantenerte informado.
                            </div>

                            <div class="btn-box">
                                <a href="/" class="theme-btn btn-style-one">
                                    <span class="btn-title">
                                        Volver al inicio <i class="fa fa-caret-right"></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Desuscripcion